<template>
  <v-layout row wrap>
    <vue-title :title="$t('contact.title')" />
    <v-flex xs12 md4 pa-3>
      <v-card>
        <v-card-title><h3 class="headline mb-0">{{ $t('contact.title') }}</h3></v-card-title>
        <v-card-text class="v-card__text">
          <p><v-icon>public</v-icon> &nbsp;&nbsp;&nbsp;<a href='http://firefighter-challenge-slovenia.si/'>http://firefighter-challenge-slovenia.si/</a></p>
          <p><v-icon>message</v-icon> &nbsp;&nbsp;&nbsp;<a href='https://www.facebook.com/FCCSLO/'>https://www.facebook.com/FCCSLO/</a></p>
        </v-card-text>
      </v-card>
    </v-flex>
    <v-flex xs12 md4 pa-3>
          <v-card>
            <v-card-title><h3 class="headline mb-0">Igor Marijan</h3></v-card-title>
            <v-card-text class="v-card__text">
              <p><v-icon>call</v-icon> &nbsp;&nbsp;&nbsp;051 368 090</p>
              <p><v-icon>mail</v-icon> &nbsp;&nbsp;&nbsp;<a href='mailto:info@firefighter-challenge-slovenia.si'>info@firefighter-challenge-slovenia.si</a></p>
            </v-card-text>
          </v-card>
    </v-flex>
    <v-flex xs12 md4 pa-3>
          <v-card>
            <v-card-title><h3 class="headline mb-0">Jure Knavs</h3></v-card-title>
            <v-card-text class="v-card__text">
              <p><v-icon>call</v-icon> &nbsp;&nbsp;&nbsp;040 528 305</p>
              <p><v-icon>mail</v-icon> &nbsp;&nbsp;&nbsp;<a href='mailto:prijave@firefighter-challenge-slovenia.si'>prijave@firefighter-challenge-slovenia.si</a></p>
              
            </v-card-text>
          </v-card>
    </v-flex>
    </v-layout>
</template>

<script>
  import {
    VTextField,
    VDataTable,
    VTooltip,
    VCard,
    VCardText,
    VCardTitle,
    VPagination
  } from 'vuetify/lib'
  import RequestsChart from '../charts/RequestsChart.vue'
  import ResponseTimeChart from '../charts/ResponseTimeChart.vue'
  import fccapi from '../fccapi.js'

  export default {
    name: 'Applications',
    data: () => ({
      requests: [],
      logs: [],
      headers: [
          { text: 'Time', align: 'left' },
          { text: 'RPM', value: 'requestsPerMinute', align: 'right' },
          { text: 'Response time', value: 'averageResponseTime', align: 'right' },
        ],
      day: 0,
      items: [],
    }),
    props: {
      source: String
    },
    components: {
      VDataTable,
      VTextField,
      VTooltip,
      VCard,
      VCardText,
      VCardTitle,
      VPagination,
      RequestsChart,
      ResponseTimeChart
    },
    mounted() {
      fccapi.get('statistics/logs').then((r) => {
          this.logs = Object.keys(r.data).map(function(key) {
              return r.data[key];
          });
          console.log(r);
      })
      fccapi.get('statistics/requests').then((r) => {
          this.requests = r.data;
      })
    },
    filters: {
      ms: function(value) {
        return Math.floor(parseFloat(value))+" ms";
      },
      timestamp: function(value) {
        var re = new RegExp(/(\d\d\d\d)-(\d\d)-(\d\d)T(\d\d):(\d\d):(\d\d)/);
        var r = value.match(re);
        return parseInt(r[4])+":"+parseInt(r[5]);
      },
      fulltimestamp: function(value) {
        var re = new RegExp(/(\d\d\d\d)-(\d\d)-(\d\d)T(\d\d):(\d\d):(\d\d)/);
        var r = value.match(re);
        return r[0].replace('T', ' ');
      }
    },
  }
</script>